"use strict";Object.defineProperty(exports, "__esModule", {value: true});/* How a group of images sent together lays out, as rows of indexes into the
 * group: two sit side by side, three are one wide tile over two, and four or
 * more show the first four as a 2x2 whose last tile counts the rest ("+N")
 * until expanded, then every image in rows of two. A lone tile fills its row. */
const COLLAPSED_TILES = 4

 const imageGridRows = (count, expanded) => {
  if (count === 3) return [[0], [1, 2]]
  const shown = expanded ? count : Math.min(count, COLLAPSED_TILES)
  const rows = []
  for (let i = 0; i < shown; i += 2) rows.push(i + 1 < shown ? [i, i + 1] : [i])
  return rows
}; exports.imageGridRows = imageGridRows

/* The number of images the collapsed grid leaves out. */
 const hiddenImageCount = (count, expanded) =>
  expanded ? 0 : Math.max(count - COLLAPSED_TILES, 0); exports.hiddenImageCount = hiddenImageCount
